import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { AdditionalEquipment, CvhVehicleSearchRow, EkoProgram, NewPriceFormValues, PriceInfoResponse, ResidualValueFormValues, ResidualValueResponse, UsedPriceFormValues } from "./types";
import { transformAdditionalEquipment, transformCvhVehicleSearchRow, transformEkoProgram, transformNewPriceRequest, transformResidualValueRequest, transformUsedPriceRequest } from "./transformations";

/**
 * Pretraga CVH osobnih vozila po JOM broju / nazivu (za autocomplete), paginirano.
 */
export const searchCvhVehiclesAPI = async (
  pagination: Pagination,
  query?: string | null
): Promise<DataWithPagination<CvhVehicleSearchRow>> => {
  let path = `/v1/catalog/vehicles/cvh/search?query=`;

  if (query) path += `${encodeURIComponent(query)}`;

  return await paginatedApiCall(path, pagination, transformCvhVehicleSearchRow);
};

export const getAdditionalEquipmentByJomAPI = async (
  jom: string
): Promise<AdditionalEquipment[]> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/cvh/jom/${encodeURIComponent(jom)}/equipment`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data.map(transformAdditionalEquipment);
};

export const calculateResidualValueAPI = async (
  formValues: ResidualValueFormValues
): Promise<ResidualValueResponse> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/cvh/residual-value/calculate`,
      method: "POST",
      body: transformResidualValueRequest(formValues),
    },
    {
      getMessage: {
        // success: () => "Rezidualna vrijednost uspješno izračunata",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data;
};

export const getEkoProgramAPI = async (): Promise<EkoProgram[]> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/cvh/ekoprogram`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data.map(transformEkoProgram);
};

export const calculateNewPriceAPI = async (
  formValues: NewPriceFormValues
): Promise<PriceInfoResponse> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/cvh/new-price/calculate`,
      method: "POST",
      body: transformNewPriceRequest(formValues),
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data;
};

export const calculateUsedPriceAPI = async (
  formValues: UsedPriceFormValues
): Promise<PriceInfoResponse> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/cvh/used-price/calculate`,
      method: "POST",
      body: transformUsedPriceRequest(formValues),
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data;
};
